import { Button, Modal, Typography } from 'antd';

const { Paragraph } = Typography;

/**
 * A settings form's answer to a stale save (delete audit F6): the API
 * refused it — 409 `stale_collection` / `stale_card` — because somebody
 * saved the record after this form loaded it, and handed back the record as
 * it stands. Nothing was written. Two ways on:
 *
 *   Reload and reapply my changes (primary) — the record as it stands
 *     becomes the form's base and the person's own edits go back on top
 *     (utils/reapply.js); the form stays open, dirty, for them to check and
 *     save again against the new version.
 *   Discard my changes — the form shows the record as it stands.
 *
 * Closing the dialog (✕, Esc) does neither: the edits stay in the form and
 * the next Save meets the same refusal.
 *
 *   noun      'collection' | 'card' — the words.
 *   overlap   labels of the fields both people changed, when there are any.
 */
export default function StaleRecordModal({ open, noun = 'record', overlap = [], onReapply, onDiscard, onClose }) {
	return (
		<Modal
			open={open}
			title={`Someone else changed this ${noun}`}
			onCancel={onClose}
			destroyOnHidden
			footer={[
				<Button key="discard" onClick={onDiscard}>Discard my changes</Button>,
				<Button key="reapply" type="primary" onClick={onReapply}>Reload and reapply my changes</Button>,
			]}
		>
			<Paragraph>
				Somebody saved this {noun} after you opened it, so your changes were not saved.
			</Paragraph>
			{overlap.length ? (
				<Paragraph>
					They changed some of the same settings you did: {overlap.join(', ')}. Reapplying puts yours back over theirs.
				</Paragraph>
			) : null}
			<Paragraph>
				Reload and reapply keeps their changes and puts yours on top, then leaves the form open so you can check
				it before you save again. Discard shows the {noun} as it is now.
			</Paragraph>
		</Modal>
	);
}
